import React, { useContext, useState } from "react";
import AppContext from "../contexts/AppContext";
import renderComponent from "../renderComponent";

function CalenderWrapperControl1({ subcomponents }) {
  console.log("Calender subcomponents", subcomponents);
  const [selectedCalenderControl, setSelectedCalenderControl] = useState(null);

  let [CalenderFilter, CalenderControl] = subcomponents;
  let customSubcomponents = [CalenderFilter, selectedCalenderControl];

  let subcomponentstoUse = [];

  if (selectedCalenderControl) {
    subcomponentstoUse = customSubcomponents;
  } else {
    subcomponentstoUse = subcomponents;
  }

  console.log("the subcomponentstoUse", subcomponentstoUse);
  console.log("the selectedcalenderControl", selectedCalenderControl);
  return (
    <>
      {subcomponentstoUse?.map((config, idx) =>
        renderComponent(config, {
          selectedCalenderControl,
          setSelectedCalenderControl,
        })
      )}
    </>
  );
}

export default CalenderWrapperControl1;
